var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle5D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_hairstyles:"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M288.3,160c-18.3,15.4-31.9,38.3-34.4,62.3c-1.2-7.9-0.9-16.8,0.7-25.9c10.9-31.5,39.5-58.3,74-58.3 c-2-12-2.4-25.6-0.8-41.1c-26.2-5.5-53.3,3.2-73.8,20.2c-4.6,3.8-8.9,8.1-12.8,12.6c-26.8,27.9-26.2,69.3-8.2,100.4 c-2.9-19.4-3.2-49.1,13.7-66c-14.6,20.9-10.7,56.8-2.9,78.7c2.5,2.4,5.2,4.6,8,6.6c1.9,1.3,3.8,2.6,5.7,3.8 c2.3,1.4,4.6,2.6,7.1,3.8c0.6,0.3,1.2,0.5,1.8,0.8c1.5-28.6,11.7-66.9,42.9-80.1c1.5-0.6,3.1-1.2,4.7-1.7 c-3.2,4.5-8.9,11.3-14.3,12.4c11.9,2.7,32.9-4.1,41.8-14c-5.1-8.7-9.3-19-11.8-31.1C314.7,145.2,299.9,150.5,288.3,160z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M436.1,107.8c-11.9,0.2-23.7,2.5-34.6,8.1c15.7-12.9,36.7-15.1,57.2-15.9c-0.7-0.7-1.3-1.4-2-2.1 c-32.3-33.8-95-36.6-125.8-0.1l0,0c-0.2,48.3,24.1,101.6,72.4,117.7c-4.3-12.5-5.3-25.6-4.8-37.7c13.7,15.6,24.9,33.1,30.7,53.1 c0.7-4.3,1.2-8.7,1.4-13.1c0.4-8.4-0.3-16.9-1.9-25.2c-1.8-8.9-4.7-17.6-8.7-25.7c28.2,39.1,31,93,14.2,138.1 c-2.1,5.7-4.6,11.2-7.4,16.5c-0.4,0.8-0.9,1.6-1.3,2.4c1.6-0.8,3.3-1.6,4.8-2.4c9.9-5.4,18.6-12.8,25.7-21.5 c5-6.3,9.2-13.1,12.6-20.1c15.1-30.8,15.4-67.2,2.3-98.9c16.5,27.7,23.5,62.3,16.8,93.8c7.9-11.5,13.5-24,14.4-38.2 c-0.2-4.7-0.9-9.5-2.1-14.4c4.5,5,7.6,10.7,9.8,16.7c0.2-1,0.3-2,0.5-3C516.1,184.7,492.1,115.1,436.1,107.8z M339.5,116.4 c5.5-10.8,13.5-19.7,25.6-24.8c14.2-5.5,27.1-4.2,41-2.8l0,0c-14.7,0.4-23.9,0.4-36.9,5.2C358.3,98.4,349.3,104.9,339.5,116.4z  M472.5,150.8c-12.4-14-26.2-23.9-43.6-30.7c18.5,3.9,33.4,13.4,46.7,28c14.9,17.5,22.6,35.8,26.4,56.9l0,0 C494.3,184.1,486.4,167.5,472.5,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A6D49",
    d: "M254.6,196.4c-1.6,9.1-1.9,18-0.7,25.9c2.5-24,16.1-46.8,34.4-62.3c11.7-9.5,26.5-14.8,41.3-16.6 c-0.4-1.7-0.7-3.5-1-5.3C294.1,138.1,265.5,164.9,254.6,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A6D49",
    d: "M406.2,88.8L406.2,88.8c-14-1.3-26.9-2.7-41.1,2.8c-12.1,5-20.1,14-25.6,24.8 c9.8-11.5,18.8-18.1,29.8-22.4C382.3,89.2,391.4,89.2,406.2,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A6D49",
    d: "M475.6,148.1c-13.3-14.7-28.2-24.1-46.7-28c17.4,6.7,31.2,16.7,43.6,30.7c13.9,16.7,21.8,33.3,29.5,54.2 l0,0C498.2,183.9,490.5,165.6,475.6,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M246.7,164.2c-16.9,16.9-16.7,46.5-13.7,66c0.5,0.9,1,1.8,1.6,2.6c2.8,3.6,5.9,7,9.2,10.1 C235.9,221.1,232,185.2,246.7,164.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M436.1,107.8c10.9-0.1,21.9,1.5,32.4,4.1c-2.9-4.3-6.2-8.3-9.7-12c-20.5,0.8-41.5,3-57.2,15.9 C412.4,110.3,424.2,108,436.1,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M471.2,181c13.1,31.7,12.8,68.1-2.3,98.9c0.2,6.2-0.3,13.1-1.5,19c7.5-7.5,14.7-15.5,20.6-24.1 C494.7,243.4,487.7,208.7,471.2,181z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M330.9,97.7L330.9,97.7L330.9,97.7c-1.1-0.3-2.1-0.5-3.2-0.7c-1.6,15.5-1.1,29.1,0.8,41.1 c0.3,1.8,0.6,3.6,1,5.3c2.5,12.1,6.7,22.4,11.8,31.1c17,28.9,45,40.8,63.1,44c-0.4-1-0.8-2.1-1.1-3.1 C355.1,199.3,330.8,146.1,330.9,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M434.3,305c16.7-45.1,14-99.1-14.2-138.1c4.1,8.1,7,16.8,8.7,25.7c15.9,45,5.8,97.3-20.5,137 c6.1-1.3,11.9-3.2,17.4-5.7c0.4-0.8,0.9-1.6,1.3-2.4C429.7,316.2,432.2,310.7,434.3,305z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle5D);
export default __webpack_public_path__ + "static/media/woman_hairstyle_5d.5b0c0a6f3807d2de6229a6d8d707d265.svg";
export { ForwardRef as ReactComponent };